import { z } from 'zod';
import { RECHTE } from './rechte';

export const KontoRolle = z.enum(['admin', 'mitarbeiter']);

export const NutzerZeile = z.object({
  id: z.string().uuid(),
  name: z.string(),
  email: z.string(),
  rolle: KontoRolle,
  rechte: z.record(z.enum(RECHTE), z.boolean()),
  aktiv: z.boolean(),
  inhaber: z.boolean(),
  /** Einladung verschickt, aber noch kein Passwort gesetzt */
  einladungOffen: z.boolean(),
  zweiFaktor: z.boolean(),
  gesperrtDurchVersuche: z.boolean(),
  letzteAnmeldung: z.string().nullable(),
});
export type NutzerZeile = z.infer<typeof NutzerZeile>;

const Rechte = z.record(z.enum(RECHTE), z.boolean());

export const NutzerEinladenSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120),
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
  rolle: KontoRolle.default('mitarbeiter'),
  rechte: Rechte.optional(),
});
export type NutzerEinladen = z.infer<typeof NutzerEinladenSchema>;

export const NutzerAendernSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120).optional(),
  rolle: KontoRolle.optional(),
  rechte: Rechte.optional(),
  aktiv: z.boolean().optional(),
});
export type NutzerAendern = z.infer<typeof NutzerAendernSchema>;

export const VersandStatus = z.enum(['gesendet', 'nicht_eingerichtet', 'fehler']);

export const EinladungErgebnis = z.object({
  nutzer: NutzerZeile,
  link: z.string(),
  versand: VersandStatus,
});
export type EinladungErgebnis = z.infer<typeof EinladungErgebnis>;

export const InhaberEinladenSchema = z.object({
  name: z.string().trim().min(2, 'Bitte Namen angeben').max(120),
  email: z.string().trim().toLowerCase().email('Bitte gültige E-Mail angeben'),
});

export const RECHT_TITEL: Record<(typeof RECHTE)[number], { titel: string; text: string }> = {
  view_dashboard: { titel: 'Übersicht', text: 'Kennzahlen und Übersicht des Marktplatzes' },
  marketplace: { titel: 'Marktplatz', text: 'Produkte, Händler, Bestellungen, Provision, Buy Box' },
  channels: { titel: 'Channels', text: 'Verkaufskanäle und Feeds' },
  payouts: { titel: 'Auszahlungen', text: 'Auszahlungen und Buchungen der Händler' },
  admin: { titel: 'Verwaltung', text: 'Einstellungen, Marktplatz-Shop, Rechnungen' },
  users: { titel: 'Nutzer', text: 'Nutzer einladen und Rechte vergeben' },
  ankauf: { titel: 'Ankauf', text: 'Ankaufanfragen bearbeiten, Angebote machen, Katalog pflegen' },
  ankauf_lesen: { titel: 'Ankauf ansehen', text: 'Ankaufanfragen nur lesen, ohne Änderungen' },
  erp: { titel: 'ERP-Connector', text: 'Verbindung zum ERP, Abgleich, Protokoll und Fehler' },
  produkte_lesen: { titel: 'Produkte ansehen', text: 'Produktliste, Details und Verlauf' },
  produkte_bearbeiten: { titel: 'Produkte bearbeiten', text: 'Einzeln und in der Tabelle ändern, freigeben, ablehnen' },
  produkte_bulk: { titel: 'Produkte in Masse', text: 'Viele Produkte auf einmal ändern oder zuordnen' },
  produkte_ki: { titel: 'Produkte mit KI', text: 'KI-Vorschläge, Anreicherung und Kategorisierung (kostet KI-Guthaben)' },
  bilder_bearbeiten: { titel: 'Bilder bearbeiten', text: 'Produktbilder hochladen und ordnen' },
  leitsystem_verwalten: { titel: 'Leitsysteme', text: 'Datenhoheit und Rückschreiben an ERP/PIM verwalten' },
};
